import { TypedUseQueryHookResult } from '@reduxjs/toolkit/dist/query/react';

import { AxiosBaseQueryFunction } from '~/api/axiosBaseQuery';
import { useFetchCustomSidesQuery } from '~/api/local-api/custom-sides.api/customSidesService';
import { CustomSideModel } from '~/core/models/predefined-custom-side.model';

type useCustomSidesReturn = Omit<
  TypedUseQueryHookResult<CustomSideModel[], void, AxiosBaseQueryFunction>,
  'data' | 'isFetching'
> & {
  areCustomSidesLoading: boolean;
  customSides?: CustomSideModel[];
};

const useCustomSides = (): useCustomSidesReturn => {
  const {
    data: customSides,
    isFetching: areCustomSidesLoading,
    ...rest
  } = useFetchCustomSidesQuery();

  return {
    areCustomSidesLoading,
    customSides,
    ...rest,
  };
};

export default useCustomSides;
